import React, { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Link,
  Typography,
  Switch,
} from "@mui/material";
import CustomButton from "shared/custom-button/CustomButton";
import { colors } from "app/providers/theme/colors-type";
import styles from "features/health-ai/step-2/ui/DocumentStep.module.css";
import { useAppDispatch, useAppSelector } from "shared/utils/hooks/useRedux";
import FileIcon from "shared/assets/FileIcon";
import Loader from "shared/loader/Loader";
import AppStoreImg from "shared/assets/AppStoreImg";
import GooglePlayImg from "shared/assets/GooglePlayImg";

import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import RuStoreImg from "shared/assets/RuStoreImg";
import ModalWidget from "shared/modal/Modal";
import { FormFieldsStepOne } from "entities/health-ai/step-1/selector";
import { IStepTwo } from "entities/health-ai/step-2/types/StepTwo-inerface";
import { fetchCalculation } from "entities/health-ai/step-2/action/fetch-step-two";
import { programs } from "entities/health-ai/step-2/selsctor";

interface DocumentStepProps {
  formState: IStepTwo;
  errors: Record<string, string>;
  handleNextStep: () => void;
  handleCheckboxChange: (
    fieldName: keyof IStepTwo
  ) => (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  handleOpenPolicy: () => void;
  errorsValidate: Record<string, string>;
  handleBack: () => void;
  windowWidth: number;
}

export const DocumentStep: React.FC<DocumentStepProps> = ({
  formState,
  errors,
  handleNextStep,
  handleCheckboxChange,
  handleOpenPolicy,
  errorsValidate,
  windowWidth,
  handleBack,
}) => {
  const dispatch = useAppDispatch();

  const formatNumberWithSpaces = (number: number): string => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const { ProgramsArray } = useAppSelector(programs);

  const [disabledBtn, setDisabledBtn] = useState(true);

  useEffect(() => {
    if (
      formState.KidAgree &&
      formState.PolicyAgree &&
      formState.InsuranceRulesAgree &&
      formState.AcceptanceAgree
    ) {
      setDisabledBtn(false);
    }
  }, [
    formState.KidAgree,
    formState.PolicyAgree,
    formState.InsuranceRulesAgree,
    formState.AcceptanceAgree,
  ]);

  return (
    <Box>
      <Box className={styles.formBox}>
        <Box className={styles.titleBox}>
          <h4>Итого премия к оплате</h4>
        </Box>
        <Box className={styles.fieldBox}>
          {ProgramsArray[0].Premium && (
            <Box className={styles.premium}>
              <span>
                {formatNumberWithSpaces(ProgramsArray[0].Premium)}{" "}
                <CurrencyRubleIcon fontSize="small" />
              </span>
            </Box>
          )}

          <p>Я подтверждаю, что до оплаты ознакомился(-ась) с </p>

          <FormControlLabel
            control={
              <Checkbox
                name="KidAgree"
                checked={Boolean(formState.KidAgree)}
                onChange={handleCheckboxChange("KidAgree")}
                sx={{
                  color: "grey.500",
                  "&.Mui-checked": {
                    color: colors.primary,
                  },
                }}
              />
            }
            label={
              <Typography variant="body2">
                <Link
                  href="https://hr-dms.ugsk.ru/%D0%9A%D0%98%D0%94%20%D0%92%D0%B0%D1%88%D0%B5%20%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D0%B5%20AI.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="always"
                >
                  Ключевым информационным документом
                </Link>
              </Typography>
            }
          />
          {errorsValidate["KidAgree"] && (
            <Typography color="error" variant="body2">
              {errorsValidate["KidAgree"]}
            </Typography>
          )}

          <FormControlLabel
            control={
              <Checkbox
                name="PolicyAgree"
                checked={Boolean(formState.PolicyAgree)}
                onChange={handleCheckboxChange("PolicyAgree")}
                sx={{
                  color: "grey.500",
                  "&.Mui-checked": {
                    color: colors.primary,
                  },
                }}
              />
            }
            label={
              <Typography variant="body2">
                <Link onClick={handleOpenPolicy}>Полисом-офертой</Link>
              </Typography>
            }
          />
          {errorsValidate["PolicyAgree"] && (
            <Typography color="error" variant="body2">
              {errorsValidate["PolicyAgree"]}
            </Typography>
          )}

          <FormControlLabel
            control={
              <Checkbox
                name="InsuranceRulesAgree"
                checked={Boolean(formState.InsuranceRulesAgree)}
                onChange={handleCheckboxChange("InsuranceRulesAgree")}
                sx={{
                  color: "grey.500",
                  "&.Mui-checked": {
                    color: colors.primary,
                  },
                }}
              />
            }
            label={
              <Typography variant="body2">
                <Link
                  href="https://ugsk.ru/pravila/109.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="always"
                >
                  Правилами страхования
                </Link>{" "}
                и{" "}
                <Link
                  href="https://hr-dms.ugsk.ru/%D0%9F%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B0%20%D0%92%D0%B0%D1%88%D0%B5%20%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D0%B5%20AI.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="always"
                >
                  существенными условиями программы
                </Link>
              </Typography>
            }
          />
          {errorsValidate["InsuranceRulesAgree"] && (
            <Typography color="error" variant="body2">
              {errorsValidate["InsuranceRulesAgree"]}
            </Typography>
          )}

          <FormControlLabel
            control={
              <Checkbox
                name="AcceptanceAgree"
                checked={Boolean(formState.AcceptanceAgree)}
                onChange={handleCheckboxChange("AcceptanceAgree")}
                sx={{
                  color: "grey.500",
                  "&.Mui-checked": {
                    color: colors.primary,
                  },
                }}
              />
            }
            label={
              <Typography variant="body2">
                Я понимаю, что оплата страховой премии является акцептом{" "}
                <Link onClick={handleOpenPolicy}>Полиса-оферты.</Link>
              </Typography>
            }
          />
          {errorsValidate["AcceptanceAgree"] && (
            <Typography color="error" variant="body2">
              {errorsValidate["AcceptanceAgree"]}
            </Typography>
          )}

          {windowWidth <= 700 ? (
            <>
              <Box className={styles.infoText}>
                <p>Полис также будет доступен в приложении</p>
                <span>Ю-Здоровье</span>
              </Box>
              <Box className={styles.linkAppBox}>
                <a
                  href="https://apps.apple.com/ru/app/%D1%8E-%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D0%B5/id6744051740?l"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AppStoreImg />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.skgaidemobile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GooglePlayImg />
                </a>
                <a
                  href="https://www.rustore.ru/catalog/app/com.skgaidemobile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <RuStoreImg />
                </a>
              </Box>
            </>
          ) : (
            <Box className={styles.infoText}>
              <p>
                Полис также будет доступен в приложении <span>Ю-Здоровье</span>
              </p>
            </Box>
          )}
        </Box>
      </Box>
      <Box className={styles.btnBoxNext}>
        <CustomButton
          title="Назад"
          handleClick={handleBack}
          textColor={colors.primary}
          backgroundColor="none"
          width="150px"
          gap="10px"
          borderRadius="4px"
          padding="3px"
          border="none"
        />
        <CustomButton
          title="Далее"
          handleClick={handleNextStep}
          textColor="white"
          backgroundColor={colors.primary}
          width="150px"
          gap="10px"
          borderRadius="4px"
          padding="3px"
          disabled={disabledBtn}
        />
      </Box>
    </Box>
  );
};
